export const FONT_SIZE_HTML = 16; // Browser default (better not to change)
export const FONT_SIZE_BODY = 14; // Browser default (better not to change)

export const CALENDAR_DAY_SIZE = 40;

// Hero $/#/% values (the primary data point of a card or KPI): Manrope, as Tradehaus sets its stats. Pair with
// VALUE_WEIGHT and VALUE_TRACKING; never apply to titles, labels, or body text.
export const VALUE_FONT = "'Manrope', sans-serif";

// Smaller inline $/#/% values: the same family since the move off Big Shoulders.
export const VALUE_FONT_SMALL = VALUE_FONT;

// A stat is a light, tightly tracked figure in tabular numerals.
export const VALUE_WEIGHT = 300;
export const VALUE_TRACKING = '-0.03em';
